import { Typography } from '@material-ui/core';
import { Translation } from '@ps/web-shared-components';
import { addSeconds, format } from 'date-fns';
import React from 'react';
import { useDispatch } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import useTimer from '@swf/core/hooks/useTimer';
import type { Dispatch } from '@swf/core/store';

import Prompt from '../../Prompt/Prompt';

import {
  TXTCLI_Inactivity_Timeout,
  TXTCLI_Logout,
  TXTCLI_You_will_be_disconnected_due_t_ELL,
  TXTWCL_Continue_using_the_site
} from './InactivityTimeoutPrompt.messages.json';

const secondsDecrement = (seconds: number) => seconds - 1;

interface Props {
  remainingSeconds: number;
  onClose: () => void;
}

const InactivityTimeoutPrompt: React.FC<Props> = ({ remainingSeconds, onClose }) => {
  const request = useRequest();
  const continueUsingSite = () => request({ service: '/api/v1-preview/account' });

  const { auth } = useDispatch<Dispatch>();

  const secondsLeft = useTimer({
    modifier: secondsDecrement,
    initial: remainingSeconds
  });

  if (secondsLeft === 0) {
    onClose();
  }

  return (
    <Prompt
      onClose={onClose}
      variant="default"
      title={{ translation: TXTCLI_Inactivity_Timeout }}
      primaryButton={{ translation: TXTWCL_Continue_using_the_site }}
      secondaryButton={{ translation: TXTCLI_Logout }}
      onPrimaryButtonClick={continueUsingSite}
      onSecondaryButtonClick={() => auth.logout()}
    >
      <Typography>
        <Translation {...TXTCLI_You_will_be_disconnected_due_t_ELL} />
      </Typography>
      <Typography>{format(addSeconds(new Date(0), secondsLeft), 'mm:ss')}</Typography>
    </Prompt>
  );
};

export default InactivityTimeoutPrompt;
